import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  setEndDate,
  setSelectedAction,
  setSelectedBrandConfigs,
  setSelectedUnifierDestinationTableId,
  setStartDate,
} from "../../../../../features/dataCollectionBrandsSlice";

const ProcessInfo = ({ onActionSelect }: any) => {
  const { selectedAction, startDate, endDate } = useSelector(
    (state: any) => state.dataCollectionBrands
  );
  const MAX_RANGE_DAYS = 90;
  const { brandDataInModal } = useSelector(
    (state: any) => state.dataCollectionBrands
  );
  const dispatch = useDispatch();
  const selectedBrands = Array.isArray(brandDataInModal)
    ? brandDataInModal?.map((item: { brandName: string }) => item.brandName)
    : [];

  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>(
    () => {
      const start = startDate ? dayjs(startDate) : dayjs().startOf("month");
      const end = endDate ? dayjs(endDate) : dayjs();
      return [start, end];
    }
  );

  const [dateError, setDateError] = useState<string | null>(null);
  const handleDateChange = (newValue: [Dayjs | null, Dayjs | null]) => {
    setDateRange(newValue);

    const [start, end] = newValue;
    if (start && end) {
      const formattedStart = start.format("YYYY-MM-DD");
      const formattedEnd = end.format("YYYY-MM-DD");

      dispatch(setStartDate(formattedStart));
      dispatch(setEndDate(formattedEnd));
      const diff = end.diff(start, "day");
      if (diff > MAX_RANGE_DAYS) {
        setDateError(`Date range cannot exceed ${MAX_RANGE_DAYS} days.`);
      } else if (diff < 0) {
        setDateError("End date must be after start date.");
      } else {
        setDateError(null);
      }
    } else {
      setDateError(null); // No error if dates are incomplete
    }
  };
  const handleActionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    dispatch(setSelectedBrandConfigs([])); // Reset selected brand configs
    dispatch(setSelectedUnifierDestinationTableId([])); // Reset selected unifier destination table ID
    dispatch(setSelectedAction(value));
    onActionSelect(value); // Notify parent
  };

  // const shouldEnableFetcher =
  //   brandDataInModal.length > 0 &&
  //   brandDataInModal.every(
  //     (brand: any) =>
  //       Array.isArray(brand.row_output_table_data) &&
  //       brand.row_output_table_data.length > 0
  //   );

  useEffect(() => {
    setDateRange([
      startDate ? dayjs(startDate) : null,
      endDate ? dayjs(endDate) : null,
    ]);
  }, [startDate, endDate]);
  return (
    <Box mt={3} mb={2}>
      <TextField
        size="small"
        fullWidth
        label="Selected Brands"
        value={selectedBrands.join(", ") || ""}
        color="secondary"
        slotProps={{
          inputLabel: {
            shrink: true,
          },
        }}
        disabled
      />
      <Box mt={2}>
        <Typography fontWeight={500}>Process Settings:</Typography>
        <Stack mt={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateRangePicker", "DateRangePicker"]}>
              <DemoItem component="DateRangePicker">
                <DateRangePicker
                  value={dateRange}
                  onChange={handleDateChange}
                  shouldDisableDate={(date) => {
                    const [, end] = dateRange;
                    return end ? date.isAfter(end, "day") : false;
                  }}
                  localeText={{
                    start: "Start Date",
                    end: "End Date",
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      size: "small",
                      color: "secondary",
                      required: true,
                      error: !!dateError,
                      helperText: dateError,
                    },
                  }}
                />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
        </Stack>
      </Box>
      <Box mt={2}>
        <Typography fontWeight={500}>Process Actions: </Typography>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={selectedAction} // Controlled component
            onChange={handleActionChange}
          >
            <FormControlLabel
              value="End_to_end_sync"
              control={<Radio color="secondary" />}
              label="End to end sync"
            />
            <FormControlLabel
              value="Fetcher"
              control={<Radio color="secondary" />}
              label="Fetcher"
            />
            <FormControlLabel
              value="Unifier"
              control={<Radio color="secondary" />}
              label="Unifier"
            />
          </RadioGroup>

          <FormHelperText sx={{ margin: "4px 0px 0 0" }}>
            Select at least one action.
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  );
};

export default ProcessInfo;
